import envelope from "../../../../commons/libs/externals/envelope";
import { useTrackingContext } from "../../container/utils/tracking-context";
import { useCommonAppDispatcher } from "../../store/hooks";
import { useSetSettings, useSettings } from "../queries/use-settings";
import useVeloconnectEndpoints from "../queries/use-veloconnect-endpoints";
import { useWawiConnectionInfo } from "../queries/use-wawi-connection";

/**
 * Teases the availability filter to dealers who have a WaWi or Veloconnect source but no assortment yet.
 * Dealers without the assortment feature (e.g. on a BASIC license) cannot set one up, so they are not teased.
 * Dismissing it is PIN-protected on the kiosk only, since mobile has no PIN dialog.
 */
const useAvailabilityFilterTeaser = () => {
  const [dispatch, actions] = useCommonAppDispatcher();
  const { mixpanel } = useTrackingContext();

  const settings = useSettings();
  const setAssortment = useSetSettings.assortment.set();
  const wawiConnectionInfo = useWawiConnectionInfo();
  const veloconnectEndpoints = useVeloconnectEndpoints();

  const hasAvailabilitySource =
    Boolean(wawiConnectionInfo.query.data?.type) || veloconnectEndpoints.areAnyEndpointsConfigured;
  const isVisible =
    settings.initialized.features.customAssortmentEnabled &&
    settings.initialized.assortment.type === null &&
    hasAvailabilitySource &&
    !settings.initialized.assortment.teaserDismissed;

  const storeDismissal = () => {
    setAssortment.mutate({ teaserDismissed: true });
    mixpanel?.trackAvailabilityFilterTeaserDismissed();
  };

  const dismiss = () => {
    if (envelope.isMobileBuild) {
      storeDismissal();
    } else {
      dispatch(actions.modal.showModal("auth", { onSuccess: storeDismissal }));
    }
  };

  return {
    isVisible,
    /** Whether the teaser can link into the dealer area, which only exists on the kiosk. */
    hasCallToAction: !envelope.isMobileBuild,
    dismiss
  };
};

export default useAvailabilityFilterTeaser;
